export default function EnterpriseScene() {
  return (
    <div className="enterprise-scene" aria-hidden="true">
      <div className="enterprise-scene__grid" />
      <div className="enterprise-scene__accent" />
    </div>
  );
}
